import { App } from "vue";
import languageRouterLink from "@/components/custom/LanguageRouterLink.vue";

export function initLanguageRouterLink(app: App<Element>) {
	app.component("language-router-link", languageRouterLink);
}
